
function getSrc(el) {
    var rawSrc = (el.attr('src') ? el.attr('src') : el.attr('data-src'));
    return rawSrc.replace(/(?=[() ])/g, '\\');
}

$(document).ready(function () {
    // Append visit widget to itinerary planner page
    var currentPath = window.location.pathname;
    var vwIframe = '<iframe src="https://palestinetx.visitwidget.com/" width="100%" height="700px" style="margin: 0 auto; display: block; box-sizing: border-box;" name="vwIframe" id="vwIframe"></iframe>';
    if (currentPath === '/p/about/295') {
        $(".content").append(vwIframe);
    }


    // Subpage Theme Styling
    if ($('body').hasClass('subpageTheme')) {
        var contentDiv = $('.content');
        var hero = $('.entityContainerRow.rowIndex-1');
        var heroImage = hero.find('.TextMediaModule:first-of-type img');
        var heroImagePath = getSrc(heroImage);
        var titleText = hero.find('.sectionHeading span').html();

        function createHero() {
            contentDiv.prepend(`<div class="subpageHeader"></div>`);
            $('.subpageHeader').css('background-image', `url("${heroImagePath}")`);
            var heroContainer = $('.subpageHeader');
            if (titleText !== undefined) {
                heroContainer.html("\
            <div class='hero-inner-content'>\
              <h1 class='hero-page-title'>"+ titleText + "</h1>\
            </div>\
          ");
            } else {
                heroContainer.html("<div class='hero-inner-content'></div>");
            }
        }

        createHero();

        var lastSection = $('.entityContainerRow').last();
        var imageGrid = lastSection.find('.imageGridModule');
        var imageGridItems = imageGrid.find('.moduleItemContainer');


        contentDiv.append("<div class='imagePanels'></div>");
        var panels = $(".imagePanels");

        imageGridItems.each(function (item) {
            var img = $(this).find("img");
            var imgSrc = getSrc(img);
            var imgPath = imgSrc.replace("&w=140", '');
            panels.append('<div class="panel-image" style="background-image: url(' + imgPath + ')"></div>');
        });

        $('.panel-image:not(:last-of-type)').wrapAll('<div class="panel-wrapper"></div>');
    }

    $('.BusinessTitleModule').find('.eventDetailDetailCost').hide();


})